export default "__VITE_ASSET__4036ee81__"